"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRouterDom = require("react-router-dom");
var _authProvider = require("./authProvider");
var _unauth = _interopRequireDefault(require("components/common/unauth"));
var _excluded = ["component"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var ProtectedRoute = function ProtectedRoute(_ref) {
  var Component = _ref.component,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_authProvider.AuthConsumer, null, function (_ref2) {
    var isAuth = _ref2.isAuth,
      userId = _ref2.userId,
      groups = _ref2.groups;
    return /*#__PURE__*/React.createElement(_reactRouterDom.Route, _extends({
      render: function render(props) {
        props.userId = userId;
        props.groups = groups;
        return isAuth ? /*#__PURE__*/React.createElement(Component, props) : /*#__PURE__*/React.createElement(_unauth["default"], null);
      }
    }, rest));
  });
};
var _default = exports["default"] = ProtectedRoute;